function SvgCableTv(props) {
  return (
    <svg viewBox="0 0 45 30" width="1em" height="1em" {...props}>
      <g fillRule="evenodd">
        <path d="M.28 2.455v22.339c0 .906.74 1.64 1.65 1.64H43c.912 0 1.65-.734 1.65-1.64V2.455c0-.906-.738-1.641-1.65-1.641H1.93c-.91 0-1.65.735-1.65 1.641zm1.873 22.117h40.625V2.677H2.153v21.895zM32.657 29.005H12.274a.567.567 0 01-.567-.564v-.43c0-.31.255-.564.567-.564h20.383c.312 0 .567.254.567.564v.43c0 .31-.255.564-.567.564" />
      </g>
    </svg>
  );
}

export default SvgCableTv;
